module.exports = __webpack_public_path__ + "static/media/9S.7051bce1.svg";